import { createSelector } from 'reselect'

import { selectCurrentContact } from 'ducks/crm/contacts/selectors/current'
import { selectCurrentCompany } from 'ducks/crm/companies/selectors/current'
import { selectCustomFieldsByKey } from './base'

function makeSelectCustomFieldsForHeader(subjectSelector, fieldKeys) {
  return createSelector(
    selectCustomFieldsByKey,
    subjectSelector,
    (fields, subject) => {
      const { customFieldValues } = subject || {}
      return fieldKeys.reduce((result, key) => {
        const customFieldValue = customFieldValues[key]
        const customField = fields[key]
        // eslint-disable-next-line no-param-reassign
        result[key] = {
          ...customFieldValue,
          ...customField,
          subjectId: subject.id,
          valueId: customFieldValue && customFieldValue.id,
        }
        return result
      }, {})
    }
  )
}

export const selectCustomFieldsForContactHeader = makeSelectCustomFieldsForHeader(
  selectCurrentContact,
  [
    'contact_email',
    'contact_first_name',
    'contact_last_name',
    'contact_secondary_email1',
    'contact_secondary_email2',
    'contact_secondary_email3',
    'contact_secondary_email4',
    'contact_secondary_email5',
  ]
)
export const selectCustomFieldsForCompanyHeader = makeSelectCustomFieldsForHeader(
  selectCurrentCompany,
  [
    'company_name',
    'company_domain',
    'company_secondary_domain1',
    'company_secondary_domain2',
    'company_secondary_domain3',
    'company_secondary_domain4',
    'company_secondary_domain5',
  ]
)
